var map = {
	"./CompactHeaderExtensions": 43612,
	"./CompactHeaderExtensions.ts": 43612,
	"./FooterExtensions": 11645,
	"./FooterExtensions.ts": 11645,
	"./HeaderExtensions": 44943,
	"./HeaderExtensions.ts": 44943,
	"./HomePageExtensions": 22654,
	"./HomePageExtensions.ts": 22654,
	"./ReadMe.md": 13979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71467;